import { TASK_INSTANCE_COMPLETED_STATUS, TASK_INSTANCE_PENDING_STATUS } from '../../constants';

export function hasAllSubtasksCompleted(taskInstance) {
  return taskInstance.subtasks?.every(isCompleted);
}

export function isCompleted(taskOrSubtask) {
  return taskOrSubtask?.status === TASK_INSTANCE_COMPLETED_STATUS;
}

export function isPending(taskOrSubtask) {
  return taskOrSubtask?.status === TASK_INSTANCE_PENDING_STATUS;
}

export function markTaskWithAllSubtasksAsCompleted(taskInstance) {
  return {
    ...taskInstance,
    subtasks: markAllSubtasksAsCompleted(taskInstance.subtasks),
    status: TASK_INSTANCE_COMPLETED_STATUS,
  };
}

export function markAllSubtasksAsCompleted(subtasks) {
  return subtasks.map((subtask) => ({
    ...subtask,
    status: TASK_INSTANCE_COMPLETED_STATUS,
  }));
}
